// extracted by mini-css-extract-plugin
module.exports = {"pintxo-modal__header":"BaseModalHeader_pintxo-modal__header__gIA79","pintxo-modal__header__slot":"BaseModalHeader_pintxo-modal__header__slot__wK7C9"};